import * as React from 'react'
import { cn } from '../../lib/utils'

export interface InputBaseProps
  extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  type?: string
  as?: 'input' | 'textarea'
  rows?: number
}

const InputBase = React.forwardRef<HTMLInputElement, InputBaseProps>(
  (
    { className, type, as = 'input', rows, autoComplete = 'off', ...props },
    ref,
  ) => {
    return as === 'textarea' ? (
      <textarea
        data-slot='textarea'
        rows={rows}
        autoComplete={autoComplete}
        className={cn(
          'flex-1 w-full min-w-0 bg-transparent border-0 outline-none no-spinner font-regular placeholder:text-neutral-surface-40',
          className,
        )}
        ref={ref as React.Ref<HTMLTextAreaElement>}
        {...props}
      />
    ) : (
      <input
        type={type}
        data-slot='input'
        autoComplete={autoComplete}
        className={cn(
          'flex-1 w-full min-w-0 bg-transparent border-0 outline-none no-spinner font-regular placeholder:text-neutral-surface-40',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)

InputBase.displayName = 'InputBase'

export { InputBase }
